export default "__VITE_ASSET__DL7s$dH7__"